import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Button} from '@betareader/design-system';
// i18n
import { withTranslation } from 'react-i18next';
import moment from 'moment';
// custom modules
import Avatar from '../../components/avatar/avatar';
import ImageSlideShow from '../../components/imageSlideshow';
import imageUtil from '../../utils/imageUtil';
import PostPrivacySelector from '../../components/feed/postPrivacySelector';

export class FeedEvent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editMode: false,
      editedText: props.event.text,
      privacy: props.event.privacy
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { editMode } = this.state;
    if (editMode && !prevState.editMode && this.textarea) {
      this.textarea.focus();
    }
  }

  toggleEditMode = () => {
    this.setState({
      editMode: !this.state.editMode
    });
  }

  handleEditedTextChange = (event) => {
    this.setState({
      editedText: event.target.value
    });
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      this.updatePost();
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      this.toggleEditMode();
    }
  }

  updatePost = () => {
    const { editedText, privacy } = this.state;
    const { event } = this.props;
    if (this.props.onUpdatePost) {
      this.props.onUpdatePost({ privacy, text: editedText, _id: event._id }, (success) => {
        if (success) {
          this.setState({
            editMode: false
          });
        }
      });
    }
  }

  deleteBookPost = () => {
    const { event } = this.props;
    if (this.props.onDeletePost) {
      this.props.onDeletePost(event);
    }
  }

  openImageSlideshow = (startIndex) => {
    this.setState({
      imageSlideshowActive: true,
      imageSlideshowStart: startIndex
    });
  }

  closeImageSlideshow = () => {
    this.setState({
      imageSlideshowActive: false,
      imageSlideshowStart: undefined
    });
  }

  handlePostPrivacyChange = (event, data) => {
    this.setState({ privacy: data.value }, () => this.updatePost());
  }

  render() {
    const { event, t, editable } = this.props;
    const {
      editMode, editedText, imageSlideshowActive, imageSlideshowStart
    } = this.state;
    return (
      <article className="br-feed-event">
        {
          imageSlideshowActive && (
            <ImageSlideShow
              images={event.images}
              startIndex={imageSlideshowStart}
              onClose={this.closeImageSlideshow}
            />
          )
        }

        <div className="br-feed-event__avatar">
          {
            event.kind === 'GroupPost'
            && <Avatar name={event.createdBy.displayName} />
          }
          {
            event.kind === 'BookPost'
            && <span aria-hidden="true">ⓘ</span>
          }
        </div>
        <div className="br-feed-event__content">
          <div className="br-feed-event__summary">
            {
              event.kind === 'BookPost'
              && (
                <span>
                  {t('BookUpdateForX')}
                  {
                    event.book.privacy !== 'unpublished' && (
                      <Link to={`/discover/${event.book._id}`}>{event.book.title}</Link>
                    )
                  }
                  {
                    event.book.privacy === 'unpublished' && (
                      <span>{event.book.title} ({t('PrivacyLevel_state_unpublished').toLowerCase()})</span>
                    )
                  }
                </span>
              )
            }
            {
              event.kind === 'GroupPost'
              && event.createdBy.displayName
            }
            <div className="br-feed-event__meta">
              <time dateTime={event.createdAt}>
                {moment(new Date(event.createdAt)).fromNow()}
              </time>
              {
                editable && (
                  <PostPrivacySelector
                    value={event.privacy}
                    onChange={this.handlePostPrivacyChange}
                    style={{ marginLeft: 5 }}
                  />
                )
              }
            </div>
          </div>
          {
            event.text && (
              editMode
                ? <textarea
                    ref={textarea => { this.textarea = textarea; }}
                    className="br-field__input br-feed-event__editor"
                    aria-label={t('EditPost', 'Edit post')}
                    value={editedText}
                    onChange={this.handleEditedTextChange}
                    onKeyDown={this.handleKeyDown}
                  />
                : <p className="br-feed-event__text">{event.text}</p>
            )
          }
          {
            event.images && event.images.length > 0
            && (
              <div className="br-feed-event__images">
                  {
                    event.images.map((image, index) => (
                      <button
                        type="button"
                        className="br-feed-event__image-button"
                        key={image._id || index}
                        onClick={() => this.openImageSlideshow(index)}
                        aria-label={`${t('ViewImage', 'View image')} ${index + 1}`}
                      >
                        <img
                          src={imageUtil.getImageUrl({
                            operation: 'width',
                            size: 150,
                            originalImageUrl: image.url
                          })}
                          alt={image.description || ''}
                        />
                      </button>
                    ))
                  }
              </div>
            )
          }
        </div>
        {
          editable && !editMode
          && (
            <div className="br-feed-event__actions">
              <Button variant="ghost" size="small" onClick={this.toggleEditMode}>{t('Edit')}</Button>
              <Button variant="ghost" size="small" onClick={this.deleteBookPost}>{t('Delete')}</Button>
            </div>
          )
        }
        {
          editable && editMode
          && (
            <div className="br-feed-event__actions">
              <Button variant="secondary" size="small" onClick={this.toggleEditMode}>{t('Cancel')}</Button>
              <Button size="small" onClick={this.updatePost}>{t('Save')}</Button>
            </div>
          )
        }
      </article>
    );
  }
}
export default withTranslation()(FeedEvent);
